import store2 from 'store2';

export default store2.namespace('autoflow');
